import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import useHook from './hooks'
import CustomModal from '../../../../components/ModalUser'
import TableAntd from '../../../../components/TableAntd'
import style from './style.module.scss'
import {
  DELIVERY_PHONE_HINT,
  isPhoneDeliveryLogistics,
} from '../../../../utils/deliveryLogistics'

// 下拉搜索关键字高亮
const LightHeightOption = (props: any) => {
  const { filterTxt, text } = props
  const heightLightTxt = (txt: string, heightTxt: string) => {
    if (heightTxt === '') {
      return txt
    }
    // 前面filterOption 不区分大小写，这里用i
    const regexp = new RegExp(heightTxt, 'gi')
    return txt.replace(regexp, '<span style="color:red">$&</span>')
  }
  return (
    <div
      ref={(nodeElement) => {
        if (nodeElement) {
          nodeElement.innerHTML = heightLightTxt(text, filterTxt)
        }
      }}
    />
  )
}

export default function AddDeliveryOrder() {
  const {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
  } = useHook()
  const formItemLayout = {
    wrapperCol: { span: 12 },
  }
  const selectedExpressRequiresPhone = () =>
    isPhoneDeliveryLogistics(
      expressSelectList.find(
        (item) => item.expressCompany === form.getFieldValue('expressCompany'),
      ),
    )
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const delCountRender = (text: any, record: any) => {
    if (isDetail) {
      return text
    }

    return (
      <Form.Item
        className={style['table-form-item']}
        name={record.id + 'deliveryQty'}
        rules={[
          {
            validator: function (rule: any, value: string) {
              if (!value) {
                return Promise.reject(new Error('发货数量必填'))
              }
              if (
                !/^[0-9]+\d{0,9}(\.\d{1,10})?$/.test(value) ||
                Number(value) === 0
              ) {
                return Promise.reject(new Error('必须是大于0且最多十位小数'))
              }
              if (parseInt(value) > parseInt(record.waitQty)) {
                return Promise.reject(new Error('大于未发数量'))
              }
              return Promise.resolve()
            },
          },
        ]}
        initialValue={record.waitQty}
      >
        <Input placeholder="请输入"></Input>
      </Form.Item>
    )
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
      width: 50,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
      width: 200,
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '规格型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
    {
      key: 'waitQty',
      dataIndex: 'waitQty',
      title: '待发数量',
    },
    {
      key: 'deliveryQty',
      dataIndex: 'deliveryQty',
      title: '本次发货数量',
      render: delCountRender,
    },
  ]

  return (
    <div>
      <div className={style['container']}>
        <Row>
          <Col span={24}>
            <div className={style['item-container']}>
              <div className={style['order-title']}>
                <span>采购订单号:{currentPageState?.code}</span>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>创建时间:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.orderCreateTime}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>采购组织:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.groupName}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>采购员:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.purchaseMan}
                  </div>
                </div>
              </Col>
              {/* <Col span={24}>
                <div className={style['item-container']}>
                  <div
                    className={style['item-label']}
                    style={{ minWidth: '60px' }}
                  >
                    收件地址:
                  </div>
                  <div className={style['item-content']}>
                    {currentPageState?.address}
                  </div>
                </div>
              </Col> */}
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>联系方式:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveMobile}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件人:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveMan}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件地址:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveAddress}
                  </div>
                </div>
              </Col>
              {/* <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发货时间:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.deliveryTime}
                  </div>
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </div>
      <div className={style['form-container']}>
        <Form {...formItemLayout} form={form}>
          <div className={style['form-table-title']}>
            <div>
              发货物料明细表
              <span className={style['table-title-span']}>
                一旦发货不可取消，请仔细核对物料信息和发货数量！
              </span>
            </div>
            <Button onClick={handleDeleteRow} className={style['button-item']}>
              删除行
            </Button>
          </div>
          <TableAntd
            dataSource={
              isDetail
                ? currentPageState?.deliveryProductList
                : currentPageState?.selectedProductList
            }
            listColumn={listColumn}
            loading={isTableLoading}
            Y={550}
            onChangeCheck={isDetail ? undefined : handleTableChangeCheck}
          ></TableAntd>
          <div className={style['form-table-title']}>物流信息</div>
          <Row>
            <Col span={5}>
              <Form.Item
                className={style['form-item']}
                name="expressCompany"
                label="物流公司"
                rules={[
                  {
                    required: true,
                    message: '物流公司必选',
                  },
                ]}
              >
                <Select
                  placeholder="请选择"
                  disabled={isDetail ? true : false}
                  allowClear
                  showSearch
                  onSearch={onExpressSearch}
                  onSelect={onExpressSelect}
                  onChange={() =>
                    form.setFields([{ name: 'expressNo', errors: [] }])
                  }
                  filterOption={(input, option: any) =>
                    (option.children &&
                      option.children.props &&
                      option.children.props.text &&
                      option.children.props.text
                        .toLowerCase()
                        .indexOf(input.toLowerCase())) >= 0
                  }
                >
                  {expressSelectList?.map((item) => {
                    return (
                      <Select.Option
                        key={item.expressCode}
                        value={item.expressCompany}
                      >
                        <LightHeightOption
                          text={item.expressCompany}
                          filterTxt={expressSearchValue}
                        ></LightHeightOption>
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
              {form.getFieldValue('expressCompany') !== '厂家配送' &&
              !selectedExpressRequiresPhone() ? (
                <Form.Item
                  className={style['form-item']}
                  name="expressNo"
                  label="物流单号"
                  extra={DELIVERY_PHONE_HINT}
                  rules={[
                    ({ getFieldValue }) => ({
                      type: 'string',
                      required: true,
                      whitespace:
                        getFieldValue('expressCompany') !== '厂家配送',
                      validator: function (rule: any, value: string) {
                        if (!value) {
                          return Promise.reject(new Error('物流单号未填写'))
                        }
                        if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                          return Promise.reject(
                            new Error('只支持输入字母、数字、反斜杠"/"'),
                          )
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="请输入"
                    disabled={isDetail ? true : false}
                    maxLength={60}
                  ></Input>
                </Form.Item>
              ) : (
                <Form.Item
                  className={style['form-item']}
                  name="expressNo"
                  label={
                    selectedExpressRequiresPhone()
                      ? '物流单号'
                      : '送货人手机号'
                  }
                  extra={
                    selectedExpressRequiresPhone()
                      ? DELIVERY_PHONE_HINT
                      : undefined
                  }
                  validateTrigger={
                    selectedExpressRequiresPhone()
                      ? ['onChange', 'onBlur']
                      : undefined
                  }
                  rules={
                    selectedExpressRequiresPhone()
                      ? [
                          {
                            type: 'string' as const,
                            required: true,
                            message: '请输入正确的11位手机号',
                            pattern: /^1[3-9]\d{9}$/,
                          },
                        ]
                      : [
                          ({ getFieldValue }) => ({
                            type: 'string' as const,
                            required: true,
                            message: '请输入正确的手机号',
                            pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                            whitespace:
                              getFieldValue('expressCompany') === '厂家配送',
                          }),
                        ]
                  }
                >
                  <Input
                    placeholder="请输入"
                    disabled={isDetail ? true : false}
                    maxLength={selectedExpressRequiresPhone() ? 60 : undefined}
                  ></Input>
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Space>
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  className={style['button-item']}
                  loading={submitBtnLoading}
                >
                  确认发货
                </Button>
              </Space>
              {/* {!isDetail ? ( ) : (
                <div>
                  <Button onClick={handleChangeDeliveryInfoClick}>
                    变更物流信息
                  </Button>
                </div>
              )} */}
            </Col>
          </Row>
        </Form>
      </div>
      <CustomModal
        title="变更物流信息"
        footer={
          <Row justify="center">
            <Button onClick={handleDeliveryInfoSave} loading={submitBtnLoading}>
              保存
            </Button>
          </Row>
        }
        modalCancel={handleChangeDeliveryInfoCancel}
        open={isChangeDeliveryInfoModalVisible}
      >
        <Form form={formModal} className={style.formStyle}>
          <Form.Item
            className={style['form-item']}
            name="expressCompany"
            label="物流公司"
            rules={[
              {
                required: true,
                message: '物流公司必选',
              },
            ]}
          >
            <Select
              placeholder="请选择"
              allowClear
              showSearch
              getPopupContainer={() => document.body}
              onSearch={onExpressSearch}
              onSelect={onExpressSelect}
              filterOption={(input, option: any) =>
                (option.children &&
                  option.children.props &&
                  option.children.props.text &&
                  option.children.props.text
                    .toLowerCase()
                    .indexOf(input.toLowerCase())) >= 0
              }
              onChange={() =>
                formModal.setFields([{ name: 'expressNo', errors: [] }])
              }
            >
              {expressSelectList?.map((item) => {
                return (
                  <Select.Option
                    key={item.expressCode}
                    value={item.expressCode}
                  >
                    <LightHeightOption
                      text={item.expressCompany}
                      filterTxt={expressSearchValue}
                    ></LightHeightOption>
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            className={style['form-item']}
            name="expressNo"
            label="物流单号"
            rules={[
              ({ getFieldValue }) => ({
                type: 'string',
                required: getFieldValue('expressCompany') !== 'XHZYWL',
                whitespace: getFieldValue('expressCompany') !== 'XHZYWL',
                validator: function (rule: any, value: string) {
                  if (!value) {
                    return Promise.reject(new Error('物流单号未填写'))
                  }
                  if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                    return Promise.reject(
                      new Error('只支持输入字母、数字、反斜杠"/"'),
                    )
                  }
                  if (value.length > 60) {
                    return Promise.reject(
                      new Error(
                        '物流单号最多输入60字，否则无法正常销售发货，多个物流单号请分开入库',
                      ),
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <Input placeholder="请输入" maxLength={60}></Input>
          </Form.Item>
        </Form>
        <Row
          justify="center"
          style={{
            color: 'red',
          }}
        >
          变更后的物流信息可能第三方平台无法更新
        </Row>
      </CustomModal>
    </div>
  )
}
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import useHook from './hooks'
import CustomModal from '../../../../components/ModalUser'
import TableAntd from '../../../../components/TableAntd'
import style from './style.module.scss'
import {
  DELIVERY_PHONE_HINT,
  isPhoneDeliveryLogistics,
} from '../../../../utils/deliveryLogistics'

// 下拉搜索关键字高亮
const LightHeightOption = (props: any) => {
  const { filterTxt, text } = props
  const heightLightTxt = (txt: string, heightTxt: string) => {
    if (heightTxt === '') {
      return txt
    }
    // 前面filterOption 不区分大小写，这里用i
    const regexp = new RegExp(heightTxt, 'gi')
    return txt.replace(regexp, '<span style="color:red">$&</span>')
  }
  return (
    <div
      ref={(nodeElement) => {
        if (nodeElement) {
          nodeElement.innerHTML = heightLightTxt(text, filterTxt)
        }
      }}
    />
  )
}

export default function AddDeliveryOrder() {
  const {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
  } = useHook()
  const formItemLayout = {
    wrapperCol: { span: 12 },
  }
  const selectedExpressRequiresPhone = () =>
    isPhoneDeliveryLogistics(
      expressSelectList.find(
        (item) => item.expressCompany === form.getFieldValue('expressCompany'),
      ),
    )
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const delCountRender = (text: any, record: any) => {
    if (isDetail) {
      return text
    }

    return (
      <Form.Item
        className={style['table-form-item']}
        name={record.id + 'deliveryQty'}
        rules={[
          {
            validator: function (rule: any, value: string) {
              if (!value) {
                return Promise.reject(new Error('发货数量必填'))
              }
              if (
                !/^[0-9]+\d{0,9}(\.\d{1,10})?$/.test(value) ||
                Number(value) === 0
              ) {
                return Promise.reject(new Error('必须是大于0且最多十位小数'))
              }
              if (parseInt(value) > parseInt(record.waitQty)) {
                return Promise.reject(new Error('大于未发数量'))
              }
              return Promise.resolve()
            },
          },
        ]}
        initialValue={record.waitQty}
      >
        <Input placeholder="请输入"></Input>
      </Form.Item>
    )
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
      width: 50,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
      width: 200,
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '规格型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
    },
    {
      key: 'waitQty',
      dataIndex: 'waitQty',
      title: '待发数量',
    },
    {
      key: 'deliveryQty',
      dataIndex: 'deliveryQty',
      title: '本次发货数量',
      render: delCountRender,
    },
  ]

  return (
    <div>
      <div className={style['container']}>
        <Row>
          <Col span={24}>
            <div className={style['item-container']}>
              <div className={style['order-title']}>
                <span>采购订单号:{currentPageState?.code}</span>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>创建时间:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.orderCreateTime}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>采购组织:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.groupName}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>采购员:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.purchaseMan}
                  </div>
                </div>
              </Col>
              {/* <Col span={24}>
                <div className={style['item-container']}>
                  <div
                    className={style['item-label']}
                    style={{ minWidth: '60px' }}
                  >
                    收件地址:
                  </div>
                  <div className={style['item-content']}>
                    {currentPageState?.address}
                  </div>
                </div>
              </Col> */}
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>联系方式:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveMobile}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件人:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveMan}
                  </div>
                </div>
              </Col>
              <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>收件地址:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.receiveAddress}
                  </div>
                </div>
              </Col>
              {/* <Col span={24}>
                <div className={style['item-container']}>
                  <div className={style['item-label']}>发货时间:</div>
                  <div className={style['item-content']}>
                    {currentPageState?.deliveryTime}
                  </div>
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </div>
      <div className={style['form-container']}>
        <Form {...formItemLayout} form={form}>
          <div className={style['form-table-title']}>
            <div>
              发货物料明细表
              <span className={style['table-title-span']}>
                一旦发货不可取消，请仔细核对物料信息和发货数量！
              </span>
            </div>
            <Button onClick={handleDeleteRow} className={style['button-item']}>
              删除行
            </Button>
          </div>
          <TableAntd
            dataSource={
              isDetail
                ? currentPageState?.deliveryProductList
                : currentPageState?.selectedProductList
            }
            listColumn={listColumn}
            loading={isTableLoading}
            Y={550}
            onChangeCheck={isDetail ? undefined : handleTableChangeCheck}
          ></TableAntd>
          <div className={style['form-table-title']}>物流信息</div>
          <Row>
            <Col span={5}>
              <Form.Item
                className={style['form-item']}
                name="expressCompany"
                label="物流公司"
                rules={[
                  {
                    required: true,
                    message: '物流公司必选',
                  },
                ]}
              >
                <Select
                  placeholder="请选择"
                  disabled={isDetail ? true : false}
                  allowClear
                  showSearch
                  onSearch={onExpressSearch}
                  onSelect={onExpressSelect}
                  onChange={() =>
                    form.setFields([{ name: 'expressNo', errors: [] }])
                  }
                  filterOption={(input, option: any) =>
                    (option.children &&
                      option.children.props &&
                      option.children.props.text &&
                      option.children.props.text
                        .toLowerCase()
                        .indexOf(input.toLowerCase())) >= 0
                  }
                >
                  {expressSelectList?.map((item) => {
                    return (
                      <Select.Option
                        key={item.expressCode}
                        value={item.expressCompany}
                      >
                        <LightHeightOption
                          text={item.expressCompany}
                          filterTxt={expressSearchValue}
                        ></LightHeightOption>
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
              {form.getFieldValue('expressCompany') !== '厂家配送' &&
              !selectedExpressRequiresPhone() ? (
                <Form.Item
                  className={style['form-item']}
                  name="expressNo"
                  label="物流单号"
                  extra={DELIVERY_PHONE_HINT}
                  rules={[
                    ({ getFieldValue }) => ({
                      type: 'string',
                      required: true,
                      whitespace:
                        getFieldValue('expressCompany') !== '厂家配送',
                      validator: function (rule: any, value: string) {
                        if (!value) {
                          return Promise.reject(new Error('物流单号未填写'))
                        }
                        if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                          return Promise.reject(
                            new Error('只支持输入字母、数字、反斜杠"/"'),
                          )
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="请输入"
                    disabled={isDetail ? true : false}
                    maxLength={60}
                  ></Input>
                </Form.Item>
              ) : (
                <Form.Item
                  className={style['form-item']}
                  name="expressNo"
                  label={
                    selectedExpressRequiresPhone()
                      ? '物流单号'
                      : '送货人手机号'
                  }
                  extra={
                    selectedExpressRequiresPhone()
                      ? DELIVERY_PHONE_HINT
                      : undefined
                  }
                  validateTrigger={
                    selectedExpressRequiresPhone()
                      ? ['onChange', 'onBlur']
                      : undefined
                  }
                  rules={
                    selectedExpressRequiresPhone()
                      ? [
                          {
                            type: 'string' as const,
                            required: true,
                            message: '请输入正确的11位手机号',
                            pattern: /^1[3-9]\d{9}$/,
                          },
                        ]
                      : [
                          ({ getFieldValue }) => ({
                            type: 'string' as const,
                            required: true,
                            message: '请输入正确的手机号',
                            pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                            whitespace:
                              getFieldValue('expressCompany') === '厂家配送',
                          }),
                        ]
                  }
                >
                  <Input
                    placeholder="请输入"
                    disabled={isDetail ? true : false}
                    maxLength={selectedExpressRequiresPhone() ? 60 : undefined}
                  ></Input>
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Space>
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  className={style['button-item']}
                  loading={submitBtnLoading}
                >
                  确认发货
                </Button>
              </Space>
              {/* {!isDetail ? ( ) : (
                <div>
                  <Button onClick={handleChangeDeliveryInfoClick}>
                    变更物流信息
                  </Button>
                </div>
              )} */}
            </Col>
          </Row>
        </Form>
      </div>
      <CustomModal
        title="变更物流信息"
        footer={
          <Row justify="center">
            <Button onClick={handleDeliveryInfoSave} loading={submitBtnLoading}>
              保存
            </Button>
          </Row>
        }
        modalCancel={handleChangeDeliveryInfoCancel}
        open={isChangeDeliveryInfoModalVisible}
      >
        <Form form={formModal} className={style.formStyle}>
          <Form.Item
            className={style['form-item']}
            name="expressCompany"
            label="物流公司"
            rules={[
              {
                required: true,
                message: '物流公司必选',
              },
            ]}
          >
            <Select
              placeholder="请选择"
              allowClear
              showSearch
              getPopupContainer={() => document.body}
              onSearch={onExpressSearch}
              onSelect={onExpressSelect}
              filterOption={(input, option: any) =>
                (option.children &&
                  option.children.props &&
                  option.children.props.text &&
                  option.children.props.text
                    .toLowerCase()
                    .indexOf(input.toLowerCase())) >= 0
              }
              onChange={() =>
                formModal.setFields([{ name: 'expressNo', errors: [] }])
              }
            >
              {expressSelectList?.map((item) => {
                return (
                  <Select.Option
                    key={item.expressCode}
                    value={item.expressCode}
                  >
                    <LightHeightOption
                      text={item.expressCompany}
                      filterTxt={expressSearchValue}
                    ></LightHeightOption>
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            className={style['form-item']}
            name="expressNo"
            label="物流单号"
            rules={[
              ({ getFieldValue }) => ({
                type: 'string',
                required: getFieldValue('expressCompany') !== 'XHZYWL',
                whitespace: getFieldValue('expressCompany') !== 'XHZYWL',
                validator: function (rule: any, value: string) {
                  if (!value) {
                    return Promise.reject(new Error('物流单号未填写'))
                  }
                  if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                    return Promise.reject(
                      new Error('只支持输入字母、数字、反斜杠"/"'),
                    )
                  }
                  if (value.length > 60) {
                    return Promise.reject(
                      new Error(
                        '物流单号最多输入60字，否则无法正常销售发货，多个物流单号请分开入库',
                      ),
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <Input placeholder="请输入" maxLength={60}></Input>
          </Form.Item>
        </Form>
        <Row
          justify="center"
          style={{
            color: 'red',
          }}
        >
          变更后的物流信息可能第三方平台无法更新
        </Row>
      </CustomModal>
    </div>
  )
}
